'use strict';

import $ from 'jquery';
import UserValidator from '@/js/modules/user_validator';
import '@/js/modules/jquery_modal_defaults';
import { onPageLoad } from '@/js/modules/page_load';

onPageLoad(() => {
  $(document).on('submit', '.sign-up__form--register', function () {
    let error = '';
    const $form = $(this);
    const email = $form.find('#user_email').val();
    const password = $form.find('#user_password').val();
    const name = $form.find('#user_name').val();
    const $submit = $form.find('button[type=submit]');

    error = UserValidator.validateEmail(email);
    $('label.form-error[for=user_email]')
      .text(error)
      .css('display', error === '' ? 'none' : 'block');

    error = UserValidator.validatePassword(password);
    $('label.form-error[for=user_password]')
      .text(error)
      .css('display', error === '' ? 'none' : 'block');

    error = UserValidator.validateName(name);
    $('label.form-error[for=user_name]')
      .text(error)
      .css('display', error === '' ? 'none' : 'block');

    if ($('.form-error:visible').length) {
      $('.form-error:visible:first').focus();
      return false;
    }

    // if no errros and availablitiy validation passed successfully
    if ($submit.hasClass('button-loading')) {
      return true;
    } else {
      const kind = 'designer-register';
      // validate email and re-submit the form as necessary
      $submit.addClass('button-loading').prop('disabled', true);
      $.post(
        '/auth/xhr_validate_availability',
        {
          email,
          name,
          kind,
        },
        function (data) {
          $.each(data, function (key, error) {
            if (key === 'email' && error === 'Email has already been taken') {
              error =
                'You already have an account. <a href="/login" class="login-instead-link">Login here</a> instead';
              $(`label.form-error[for=user_${key}]`).html(error).css('display', 'block');
            } else {
              $(`label.form-error[for=user_${key}]`).html(error).css('display', 'block');
            }
          });

          if ($('.form-error:visible').length) {
            $('.form-error:visible:first').focus();
            $submit.removeClass('button-loading').prop('disabled', false);
          } else {
            $form.submit();
          }
        }
      );
    }
    return false;
  });

  if (window.location.href.indexOf('test=true') > 1) {
    $('#modal--greetings').modal();
  }
});
